export default __webpack_public_path__ + "assets/png/190f628e36cd097ccdfc6790484f4b10.png";